// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Component, OnDestroy, ViewEncapsulation, forwardRef, input } from "@angular/core";
import { InputFormWrapper } from "../wrapper.interface";
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { SharedModule } from "primeng/api";
import { AutoFocusModule } from "primeng/autofocus";
import { ButtonModule } from "primeng/button";
import { RippleModule } from "primeng/ripple";
import { VButtonComponent } from "../button/button.component";
import { VDateModule } from "src/app/components/v-date/v-date.module";
import { V_FORM_CONTROL_TOKEN, WRAPPER_TOKEN } from "../wrapper.tokens";
import { TimePickerConfig } from "./timePicker.config";
import { VDatePickerBaseComponent } from "../datePicker/datePicker.base.component";
import { Duration } from "luxon";
import { TranslateModule } from "@ngx-translate/core";
import { VIconComponent } from "src/app/components/v-icon/v-icon.component";

@Component({
    selector:      'v-time-picker',
    templateUrl:   './timePicker.component.haml',
    styleUrls:     ['./timePicker.component.sass', '../input.style.sass'],
    encapsulation: ViewEncapsulation.None,
    providers:     [
        { provide: V_FORM_CONTROL_TOKEN, useExisting: forwardRef(() => VTimePickerComponent) },
        { provide: WRAPPER_TOKEN, useExisting: forwardRef(() => VTimePickerComponent) },
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => VTimePickerComponent), multi: true }
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        ButtonModule,
        SharedModule,
        RippleModule,
        AutoFocusModule,
        VIconComponent,
        VDateModule,
        VButtonComponent,
        VDatePickerBaseComponent,
        TranslateModule
    ]
})
export class VTimePickerComponent extends InputFormWrapper<TimePickerConfig, Duration> implements OnDestroy {
    protected _baseConfig: TimePickerConfig = TimePickerConfig.baseTheme.Default;
    public readonly format = "hh:mm";

    // public readonly maxTime = input<DateTime, Duration>(undefined, {transform: (x: Duration) => DateTime.now().startOf('day').plus(x)});
    // public readonly minTime = input<DateTime, Duration>(undefined, {transform: (x: Duration) => DateTime.now().startOf('day').plus(x)});
}